export default {

    //заполнить данные по web пользователям
    loadWebUsers(state, data) {
        state.webUsers = data;
    },

    //заполнить данные по mobile пользователям
    loadMobileUsers(state, data) {
        state.mobileUsers = data;
    },

    //обновить
    editWeb(state, editdata) {
        var ind = state.webUsers.findIndex(x => x.id == editdata.id)
        if (ind != -1 && ind != undefined) {
            state.webUsers.splice(ind, 1, editdata);
        }
    },

    //обновить аватар пользователя
    changeWebUSerLogo(state, logoModel) {
        var ind = state.webUsers.findIndex(x => x.identityId == logoModel.identityId)
        if (ind != -1 && ind != undefined) {
            state.webUsers[ind].webUserLogo = logoModel.webUserLogo;
            state.webUsers.splice();
        }
    },
    //добавить
    addWeb(state, newdata) {
        state.webUsers.push(newdata)
    },

    //удалить
    deleteWeb(state, fineId) {
        var ind = state.webUsers.findIndex(x => x.id == fineId)
        if (ind != -1 && ind != undefined) {
            state.webUsers.splice(ind, 1);
        }
    },

    //обновить Mobile
    editMobile(state, editdata) {
        var ind = state.mobileUsers.findIndex(x => x.id == editdata.id)
        if (ind != -1 && ind != undefined) {
            state.mobileUsers.splice(ind, 1, editdata);
        }
    },

    //добавить Mobile
    addMobile(state, newdata) {
        state.mobileUsers.push(newdata)
    },

    //удалить Mobile
    deleteMobile(state, fineId) {
        var ind = state.mobileUsers.findIndex(x => x.id == fineId)
        if (ind != -1 && ind != undefined) {
            state.mobileUsers.splice(ind, 1);
        }
    },

    //записать список активаций
    setClientActivates(state, data) {
        state.activates = data
    },

    //записать список бонусов клиента
    setClientBonuses(state, data) {
        state.bonuses = data
    },

}
